/**
 * <hi-carousel>: carrossel leve com scroll-snap (desliza no dedo), setas,
 * pontos e passagem automática opcional (data-autoplay em segundos).
 * Pausa quando a cliente interage, quando sai da tela e com movimento reduzido.
 */
class HiCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.hi-carousel__track');
    this.slides = [...this.querySelectorAll('.hi-carousel__slide')];
    this.dots = [...this.querySelectorAll('.hi-carousel__dot')];
    if (!this.track || this.slides.length < 2) return;

    this.index = 0;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelectorAll('.hi-carousel__arrow').forEach((btn) =>
      btn.addEventListener('click', () => this.go(this.index + Number(btn.dataset.dir)))
    );
    this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.index))));

    let ticking = false;
    this.track.addEventListener(
      'scroll',
      () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
          if (i !== this.index) this.setIndex(i);
        });
      },
      { passive: true }
    );

    const seconds = Number(this.dataset.autoplay) || 0;
    if (seconds > 0 && !this.reduced) {
      this.delay = seconds * 1000;
      this.paused = false;
      this.visible = false;
      const pause = () => (this.paused = true);
      const resume = () => (this.paused = false);
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', resume);
      this.track.addEventListener('touchstart', pause, { passive: true });
      new IntersectionObserver(([entry]) => (this.visible = entry.isIntersecting), { threshold: 0.4 }).observe(this);
      this.timer = setInterval(() => {
        if (this.visible && !this.paused && !document.hidden) this.go(this.index + 1);
      }, this.delay);
    }
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  go(i) {
    const n = this.slides.length;
    const next = ((i % n) + n) % n;
    const left = this.slides[next].offsetLeft;
    // Da última para a primeira volta direto (sem atravessar todas as fotos).
    const smooth = !this.reduced && !(this.index === n - 1 && next === 0);
    this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'auto' });
    this.setIndex(next);
    // Garantia: se a animação não concluir (aba em segundo plano etc.), posiciona direto.
    clearTimeout(this.fallback);
    this.fallback = setTimeout(() => {
      if (Math.abs(this.track.scrollLeft - left) > 2) this.track.scrollTo({ left, behavior: 'auto' });
    }, 900);
  }

  setIndex(i) {
    this.index = i;
    this.dots.forEach((dot, d) => dot.toggleAttribute('aria-current', d === i));
  }
}

if (!customElements.get('hi-carousel')) customElements.define('hi-carousel', HiCarousel);
